import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dev-ops-outage-form',
  templateUrl: './dev-ops-outage-form.component.html',
  styleUrls: ['./dev-ops-outage-form.component.css'],
})
export class DevOpsOutageFormComponent {
  class: string = 'active';
  previewbol: boolean = false;
  outagebol: boolean = true;
  loading: boolean = false;

  outageinputval: any = {};
  emails: any;
  statusAvailable: boolean = false;
  returndata: any;
  responseMessage:  string = "";
  constructor(private http: HttpClient) {}

  preview(e: any) {
    e.preventDefault();
    this.previewbol = true;
    this.outagebol = false;
    console.log(this.outageinputval);
  }
  goback() {
    this.outagebol = true;
    this.previewbol = false;
  }

  email() {
    console.log(1, this.outageinputval.environment);
    if (this.outageinputval.environment == 'Dev') {
      this.emails = 'dummymaildevops@maistering.com';
    } else if (this.outageinputval.environment == 'Beta') {
      this.emails = 'beta-release@maistering.com';
    } else if (this.outageinputval.environment == 'QA') {
      this.emails = 'qa-release@maistering.com';
    } else if (this.outageinputval.environment == 'Stage') {
      this.emails = 'stage-release@maistering.com';
    } else if (this.outageinputval.environment == 'IDay') {
      this.emails = 'iday-release@maistering.com';
    } else if (this.outageinputval.environment == 'MC4MA') {
      this.emails = 'mc4ma-release@maistering.com';
    } else if (this.outageinputval.environment == 'MC4EA') {
      this.emails = 'mc4ea-release@maistering.com';
    } else if (this.outageinputval.environment == 'MC4TC') {
      this.emails = 'mc4tc-release@maistering.com';
    } else if (this.outageinputval.environment == 'MC4OC') {
      this.emails = 'mc4oc-release@maistering.com';
    } else if (this.outageinputval.environment == 'MC4BW') {
      this.emails = 'mc4bw-release@maistering.com';
    } else if (this.outageinputval.environment == 'MC4MB') {
      this.emails = 'mc4mb-release@maistering.com';
    }
    console.log(this.emails);
  }
  sendemail(): void {
    this.getmethod();
  }
  getmethod() {
    // console.log(this.outageinputval.weblink)
    this.loading = true;
    setTimeout(() => {
      console.log(1);
      // Call the setDelay function again with the remaining times
      this.loading = false;
    }, 2000);
    this.http
      .put(
        `https://mbvdevopsapi.maistering.com/outage?from_email=${this.outageinputval.fromemailid}&to_email=${this.emails}&subject=${this.outageinputval.emailsubject}&env=${this.outageinputval.environment}&what=${this.outageinputval.what}&when=${this.outageinputval.when}&nextupdate=${this.outageinputval.nextupdate}&impact=${this.outageinputval.impact}&template_id=${this.outageinputval.templateid}&outage=${this.outageinputval.outage}&weblink=${this.outageinputval.weblink}`,
        this.outageinputval
      )
      .subscribe({
        next: (data:any) => {
            this.statusAvailable = true;
            this.returndata = data["status_code"];
            if(this.returndata == 200){
              this.responseMessage = ": Mail Sent Successfully!"
            } else {
              this.responseMessage = ": Mail Sent Successfully!"
            }
          },
        error : (err) => {
          this.statusAvailable = true;
          this.responseMessage = ": Oops...! Something Went Wrong!"
        },
        complete:() => {

        }
      })
  }
}
